import React from 'react'
import axios from 'axios'
import styled from 'styled-components/macro'
import { Button } from 'components'

const Wrapper = styled.div`
	max-width: 600px;
	margin: 0 auto;
	padding: 0 30px;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;

	h1,
	p {
		margin: 0px;
		margin-bottom: 1rem;
	}
`

const Success = ({ match }) => {
	const applicationId = match.params.applicationId
	const [demoMode, setDemoMode] = React.useState(false)
	const [application, setApplication] = React.useState(null)

	React.useEffect(() => {
		axios
			.get('/api/site-config')
			.then(res => setDemoMode(!!res.data.demoMode))
			.catch(() => {})

		axios
			.get(`/api/applications/${applicationId}`)
			.then(res => setApplication(res.data))
			.catch(() => {})
	}, [applicationId])

	return (
		<Wrapper>
			<h1>Kiitos!</h1>
			<p>Yrityssaneeraushakemus on nyt luotu.</p>
			{demoMode ? (
				<p>
					Allekirjoituskutsut on lähetetty Visma Signin kautta. Voit ladata
					asiakirjat alta. Valmiit viestit lähetetään osakkaille ja
					valtuuttajalle – hakemusta ei lähetetä käräjäoikeudelle.
				</p>
			) : (
				<>
					<p>
						Alla olevat asiakirjat on lähetetty allekirjoitettavaksi
						tarvittaville asianosaisille.
					</p>
					<p>
						Allekirjoitusten jälkeen kyseiset asiakirjat toimitetaan yrityksesi
						kotipaikan mukaan määräytyvän käräjäoikeuden käsiteltäväksi.
					</p>
				</>
			)}
			<p>Käy katsomassa sähköpostisi jatko-ohjeiden osalta.</p>
			<p>
				<a
					target="_blank"
					rel="noopener noreferrer"
					href={'/api/applications/' + applicationId + '/invoice'}
				>
					Lataa kuitti
				</a>
			</p>
			<h1>Luodut asiakirjat:</h1>
			<a
				target="_blank"
				rel="noopener noreferrer"
				href={'/api/applications/' + applicationId + '/boardnotes'}
			>
				Päätöspöytäkirja
			</a>
			<a
				target="_blank"
				rel="noopener noreferrer"
				href={'/api/applications/' + applicationId + '/application'}
			>
				Hakemus
			</a>
			{application?.status && application.status !== 'FINISHED' && (
				<p>
					Allekirjoitukset ovat vielä kesken.{' '}
					<a href={`/form/${applicationId}/signing`}>
						Palaa allekirjoitusvaiheeseen
					</a>
				</p>
			)}
			<p>&nbsp;</p>
			<Button as="a" href="/" variant="filled">
				Takaisin alkuun
			</Button>
		</Wrapper>
	)
}

export default Success
